// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3615": "995efd144f0e","5981": "9200fc8d30ac","9747": "b9c5d2e3b3b2",}[chunkId] + ".css"
}